module.exports = __webpack_public_path__ + "static/media/vkontra.75bb9999.jpg";